/**
 * Route for `advertiser-invoices`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserInvoicesPage } from "../features/advertiser-invoices/AdvertiserInvoicesPage";

export const advertiserInvoicesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-invoices",
	component: AdvertiserInvoicesPage,
});

export default advertiserInvoicesRoute;
